import { getFontFamily as getInaccessibleFontFamily } from './fontFamily/themes/InaccessibleLight/alias';
import { getFontSize as getInaccessibleFontSize } from './fontSize/themes/InaccessibleLight/alias';
import { getFontStyle as getInaccessibleFontStyle } from './fontStyle/themes/InaccessibeLight/alias';
import { getFontStyle as getLightFontStyle } from './fontStyle/themes/Light/alias';
import { getFontWeight as getInaccessibleFontWeight } from './fontWeight/themes/InaccessibleLight/alias';
import { getLineHeight as getInaccessibleLineHeight } from './lineHeight/themes/InaccessibleLight/alias';
import { getTextAlign as getInaccessibleTextAlign } from './textAlign/themes/InaccessibleLight/alias';
import { getTextDecoration as getInaccessibleTextDecoration } from './textDecoration/themes/InaccessibleLight/alias';
import { getTextDecorationThickness as getInaccessibleTextDecorationThickness } from './textDecorationThickness/themes/InaccessibleLight/alias';
import { getTextUnderlineOffset as getInaccessibleTextUnderlineOffset } from './textUnderlineOffset/themes/InaccessibleLight/alias';
import { getVerticalAlign as getInaccessibleVerticalAlign } from './verticalAlign/themes/InaccessibleLight/alias';
export function getFontFamily(transformer, config) {
    return getInaccessibleFontFamily(transformer, config);
}
export function getFontSize(transformer) {
    return getInaccessibleFontSize(transformer);
}
export function getFontStyle(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightFontStyle(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightFontStyle(transformer);
    }
    return getInaccessibleFontStyle(transformer);
}
export function getFontWeight(transformer) {
    return getInaccessibleFontWeight(transformer);
}
export function getLineHeight(transformer) {
    return getInaccessibleLineHeight(transformer);
}
export function getTextAlign(transformer) {
    return getInaccessibleTextAlign(transformer);
}
export function getTextDecoration(transformer) {
    return getInaccessibleTextDecoration(transformer);
}
export function getTextDecorationThickness(transformer) {
    return getInaccessibleTextDecorationThickness(transformer);
}
export function getTextUnderlineOffset(transformer) {
    return getInaccessibleTextUnderlineOffset(transformer);
}
export function getVerticalAlign(transformer) {
    return getInaccessibleVerticalAlign(transformer);
}
